module.exports = __webpack_public_path__ + "img/t-2.53d50f57.png";